import {CommonModule} from '@angular/common';
import {isDevMode, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {TokenInterceptor} from "./core/interceptors/token.interceptor";
import {ErrorInterceptor} from "./core/interceptors/error.interceptor";
import {NgxPermissionsModule} from "ngx-permissions";

// PrimeNG
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {MessageService, ConfirmationService} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';

import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {NgSelectModule} from "@ng-select/ng-select";
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule, MatOptionModule} from '@angular/material/core';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MethodsUtils} from "@shared/utils/methods.utils";
import {GuestLayoutComponent} from './layout/guest-layout/guest-layout.component';
import {ChangeStatusDialogComponent} from './demo/change-status-dialog/change-status-dialog.component';
import {CoreModule} from "@shared/core.module";
import {MatInputModule} from "@angular/material/input";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NgxImageCompressService} from "ngx-image-compress";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {MatSelectModule} from "@angular/material/select";
import { initializeApp } from "firebase/app";
import {environment} from "@env";
import {MatDividerModule} from "@angular/material/divider";
import {ServiceWorkerModule} from "@angular/service-worker";
import {LayoutModule} from './layout/layout.module';
import {RouterModule} from "@angular/router";

initializeApp(environment.firebase);

@NgModule({
    declarations: [
        AppComponent,
        ChangeStatusDialogComponent,
        GuestLayoutComponent,
    ],
    exports: [MatDatepickerModule],
    bootstrap: [AppComponent],
    imports: [
        MatDatepickerModule,
        AngularEditorModule,
        BrowserModule,
        AppRoutingModule,
        MatButtonModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatMomentDateModule,
        NgSelectModule,
        MatDividerModule,
        NgxPermissionsModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        BrowserAnimationsModule,
        CoreModule,
        MatInputModule,
        NgxMaskDirective,
        MatTooltipModule,
        MatOptionModule,
        MatSelectModule,
        MatButtonModule,
        CommonModule,
        LayoutModule,
        RouterModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
    providers: [
        MethodsUtils,
        NgxImageCompressService,
        provideNgxMask(),
        MessageService,
        ConfirmationService,
        DialogService,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: { darkModeSelector: false }
            }
        }),
    ]
})
export class AppModule {
}
